import { AuroraAssetGroup } from '../types'
import { useState } from 'react'
import { setAuroraCirculationPumpStatus } from '../services/aurora'
import { AuroraCirculationPumpStatus } from '../enums'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { createErrorNotification, createSuccessNotification } from '../redux/slices/notifications'
import AuroraCirculationPumpStatusControl from './AuroraCirculationPumpStatusControl'
import { useAuroraStack } from '../hooks'

export interface AuroraAssetGroupCirculationPumpStatusControlProps {
  auroraAssetGroup: AuroraAssetGroup
  beforeSubmit?: (status: AuroraCirculationPumpStatus) => void
  afterSubmit?: (status: AuroraCirculationPumpStatus) => void
  onError?: (error: unknown) => void
}

export default function AuroraAssetGroupCirculationPumpStatusControl({
  auroraAssetGroup,
  beforeSubmit,
  afterSubmit,
  onError
}: AuroraAssetGroupCirculationPumpStatusControlProps) {
  const { t } = useTranslation('aurora')

  const dispatch = useDispatch()

  const {
    auroras,
    circulationPumpStatus: initialCirculationPumpStatus,
    handleAuroraAwhpActionError
  } = useAuroraStack(auroraAssetGroup)

  const [status, setStatus] = useState<AuroraCirculationPumpStatus>(initialCirculationPumpStatus)

  const [isSubmitting, setSubmitting] = useState<boolean>(false)

  async function handleSubmit(status: AuroraCirculationPumpStatus) {
    try {
      setSubmitting(true)

      beforeSubmit?.(status)

      await Promise.all(auroras.map((aurora) => setAuroraCirculationPumpStatus(aurora.id, status)))
      setStatus(status)
      dispatch(createSuccessNotification(t('setCirculationPumpStatusSuccess')))

      afterSubmit?.(status)
    } catch (error) {
      onError?.(error)
      handleAuroraAwhpActionError(error, t('setCirculationPumpStatusError'))
    } finally {
      setSubmitting(false)
    }
  }

  if (auroras.length === 0) {
    return null
  }

  return (
    <AuroraCirculationPumpStatusControl
      value={status}
      loading={isSubmitting}
      onSubmit={handleSubmit}
    />
  )
}
